/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SerieVideoLangViewModelPaginatedResponse } from "../types/SerieVideoLangViewModelPaginatedResponse.ts";
import { serieVideoLangViewModelSchema } from "./serieVideoLangViewModelSchema.ts";

export const serieVideoLangViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => serieVideoLangViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<SerieVideoLangViewModelPaginatedResponse>;
